jQuery(document).ready(function () {
	//Mobile menu
	$(".header-menu-button").on("click", function () {
		$(".nav-main").fadeToggle(300);
		$(this).toggleClass("open");
		$("body, html").toggleClass("open");
		$(".header-search-button").toggleClass("open");
	});

	$(".header-search-button, .header-search-mask").on("click", function () {
		$(".header-search").fadeToggle(300);
		$(".header-search-mask").fadeToggle(300);
		$("body, html").toggleClass("open");
		$(".header-search input").focus();
	});

	//Book cover shadow
	$(".book-small__img, .hp-block__book, .book-block__img").on(
		"inview",
		function () {
			$(this).addClass("shadow");
		}
	);

	//Book detail carousel
	$(".other-books-carousel").slick({
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 1,

		responsive: [{
				breakpoint: 768,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	//Books listing menu button
	$(".aside-menu-button").on("click", function () {
		$(".books-listing__aside-list").slideToggle();
	});

	//Selectbox
	$(".sort-by__select").selectric();

	//Books listing aside-nav bullet
	$(".bullet").prepend('<div class="bullet-el"></div>');

	galleryFancybox();

	booksAsideNav();

	matchHeightAll();

	bookImgMobile();

	hpSliderInit();

	//Fancybox
	$("[data-fancybox]").fancybox({
		buttons: ["close"]
	});

	//Fancybox
	$(".kt-img-link").fancybox({
		buttons: ["close"]
	});
});

//Match height -----------------
function matchHeightAll() {
	$(".book-small__heading").matchHeight();
	$(".authors-letter__author").matchHeight();
	$(".book-block__top").matchHeight();
}

//Authors listing scroll to top -----------------
$(".alphabet-bar__letter").on("click", function () {
	//$('.authors-scroll-top').fadeIn(300);
});

$(".authors-scroll-top").on("click", function () {
	//$(this).fadeOut(300);
});

// On window resize ---------------
$(window).resize(function () {
	matchHeightAll();

	if ($(window).width() > 768) {
		$(".nav-main, .header-search, .header-search-mask").removeAttr("style");
		$(".header-menu-button, body, html").removeClass("open");
	}

	if ($(window).width() < 992) {
		$(".book-detail__nav")
			.detach()
			.prependTo(".has-nav");
		$(".book-detail__nav").removeClass("scrolled");

		$(".book-detail__book-img")
			.detach()
			.prependTo(".book-detail-top");
		$(".book-detail__book-img").removeClass("scrolled");
	}

	if ($(window).width() > 991) {
		$(".books-listing__aside-list").removeAttr("style");
	}

	booksAsideNav();

	bookImgMobile();
});

// On scroll Book detail Nav
jQuery(window).bind("scroll", function () {
	if ($(".alphabet-bar").length) {
		auhtorsToTop();
	}

	if ($(".book-detail").length) {
		bookDetailBookCoverScroll();
		//bookDetailNavOverlap();
		bookDetailNavScroll();
		bookDetailNavNew();
	}
});

//Authors listing scroll

function auhtorsToTop() {
	var distance = $(".alphabet-bar__letter").offset().top,
		$window = $(window),
		$button = $(".authors-scroll-top");

	$window.scroll(function () {
		if ($window.scrollTop() >= distance) {
			if (!$button.is(":visible")) {
				$($button).fadeIn(300);
			}
		} else {
			if ($button.is(":visible")) {
				$($button).fadeOut(300);
			}
		}
	});
}

//Book detail scroll
function bookDetailBookCoverScroll() {
	var fromTop = 0;

	fromTop += $(".header-main").height();

	if ($(".page-heading").length) {
		fromTop += $(".page-heading").height();
	}

	if ($("#breadcrumb").length) {
		fromTop += $("#breadcrumb").height();
	}

	fromTop += 40;

	var fromTopBottom = 0;
	fromTopBottom += $(".header-main").height();

	if ($(".page-heading").length) {
		fromTopBottom += $(".page-heading").height();
	}

	if ($("#breadcrumb").length) {
		fromTopBottom += $("#breadcrumb").height();
	}
	fromTopBottom += $(".book-detail").height();

	fromTopBottom -= $(".book-detail-bottom").height();

	fromTopBottom -= 470;

	if ($(window).width() > 991) {
		if ($(window).scrollTop() < fromTop) {
			$(".book-detail__book-img").removeClass("scrolled");
			$(".book-detail__book-img")
				.detach()
				.prependTo(".book-detail-top");
		} else {
			jQuery(".book-detail__book-img").addClass("scrolled");
			$(".book-detail__book-img")
				.detach()
				.appendTo("main");
		}

		if ($(window).scrollTop() > fromTopBottom) {
			$(".book-detail__book-img")
				.detach()
				.prependTo(".book-detail-bottom");
			$(".book-detail__book-img").removeClass("scrolled");
			$(".book-detail__book-img").addClass("scrolled-bottom");
		} else {
			$(".book-detail__book-img").removeClass("scrolled-bottom");
		}
	}
}

function bookDetailNavScroll() {
	var fromTop = 0;

	fromTop += $(".header-main").height();

	if ($(".page-heading").length) {
		fromTop += $(".page-heading").height();
	}

	if ($("#breadcrumb").length) {
		fromTop += $("#breadcrumb").height();
	}

	fromTop += $(".book-detail-top").height();

	fromTop -= 437;

	var fromTopBottom = 0;
	fromTopBottom += $(".header-main").height();

	if ($(".page-heading").length) {
		fromTopBottom += $(".page-heading").height();
	}

	if ($("#breadcrumb").length) {
		fromTopBottom += $("#breadcrumb").height();
	}
	fromTopBottom += $(".book-detail").height();

	fromTopBottom -= $(".book-detail-bottom").height();

	fromTopBottom -= 473;

	if ($(window).width() > 991) {
		if ($(window).scrollTop() < fromTop) {
			$(".book-detail__nav").removeClass("scrolled");
			$(".book-detail__nav")
				.detach()
				.prependTo(".has-nav");
		} else {
			jQuery(".book-detail__nav").addClass("scrolled");
			$(".book-detail__nav")
				.detach()
				.appendTo("main");
		}

		if ($(window).scrollTop() > fromTopBottom) {
			$(".book-detail__nav")
				.detach()
				.prependTo(".book-detail-bottom");
			$(".book-detail__nav").removeClass("scrolled");
			$(".book-detail__nav").addClass("scrolled-bottom");
			removeActiveItem();
			$(".book-detail__nav-item")
				.last()
				.addClass("active");
		} else {
			$(".book-detail__nav").removeClass("scrolled-bottom");
		}
	}
}

function bookDetailNavNew() {
	var menu = $(".book-detail__book-img").offset();

	if ($(".book-detail__nav").hasClass("scrolled")) {
		$(".book-detail__nav-item").each(function () {
			var sectionClass = $(this).attr("data-kt-target");

			var item = $(sectionClass).offset();

			if (menu.top >= item.top - 10) {
				removeActiveItem();
				$(this).addClass("active");
			}
		});
	}
}

function bookDetailNavOverlap() {
	var menu = $(".book-detail__nav").offset();

	if ($(".about-book").length) {
		var item1 = $(".about-book").offset();

		if (menu.top >= item1.top - 70) {
			removeActiveItem();
			$(".about-book-nav").addClass("active");
		}
	}

	if ($(".reviews").length) {
		var item2 = $(".reviews").offset();

		if (menu.top >= item2.top - 70) {
			removeActiveItem();
			$(".reviews-nav").addClass("active");
		}
	}

	if ($(".about-author").length) {
		var item3 = $(".about-author").offset();

		if (menu.top >= item3.top - 70) {
			removeActiveItem();
			$(".about-author-nav").addClass("active");
		}
	}

	if ($(".book-details").length) {
		var item4 = $(".book-details").offset();

		if (menu.top >= item4.top - 70) {
			removeActiveItem();
			$(".book-details-nav").addClass("active");
		}
	}
}

function removeActiveItem() {
	$(".book-detail__nav-item").each(function () {
		$(this).removeClass("active");
	});
}

function hpSliderInit() {
	if ($(".hp-slider").length) {
		$(".hp-slider").slick({
			// lazyLoad: "ondemand",
			lazyLoad: "progressive",
		});
	}

}

//Book detail img mobile
function bookImgMobile() {
	if ($(window).width() < 576) {
		$(".book-detail__book-img")
			.detach()
			.insertAfter(".book-detail__info-authors");
		$(".book-detail__book-img").show();
	}
}

function booksAsideNav() {
	if ($(window).width() < 992) {
		$(".books-listing__aside")
			.detach()
			.insertAfter(".books-listing__inner>header");
		$(".books-listing__aside").show();
	}

	if ($(window).width() > 991) {
		$(".books-listing__aside")
			.detach()
			.prependTo(".books-listing");
		$(".books-listing__aside").css("display", "flex");
	}
}

//Fancybox init

//WP gallery fancybox
function galleryFancybox() {
	var galleryID = "I";

	$(".gallery").each(function () {
		//$(this).find('.gallery-icon a').addClass(galleryID);
		$(this)
			.find(".gallery-icon a")
			.attr("data-fancybox", galleryID);
		galleryID += "I";
	});
}